var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 19.1666H9.16667V0.833252H10.8333V19.1666ZM7.5 15.8333H4.16667V4.16659H7.5V2.49992H4.16667C3.24167 2.49992 2.5 3.24159 2.5 4.16659V15.8333C2.5 16.2753 2.67559 16.6992 2.98816 17.0118C3.30072 17.3243 3.72464 17.4999 4.16667 17.4999H7.5V15.8333ZM15.8333 5.83325V7.49992H17.5V5.83325H15.8333ZM15.8333 4.16659H17.5C17.5 3.72456 17.3244 3.30063 17.0118 2.98807C16.6993 2.67551 16.2754 2.49992 15.8333 2.49992V4.16659ZM17.5 12.4999H15.8333V14.1666H17.5V12.4999ZM15.8333 9.16659V10.8333H17.5V9.16659H15.8333ZM14.1667 2.49992H12.5V4.16659H14.1667V2.49992ZM15.8333 17.4999C16.7583 17.4999 17.5 16.7583 17.5 15.8333H15.8333V17.4999ZM14.1667 15.8333H12.5V17.4999H14.1667V15.8333Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.bc95ca61889588e14d07ccbdb30fcb83.svg";
export { ForwardRef as ReactComponent };